import './css/styles.css';
import './css/responsive.css';
import defaultFelixAvatar from '/icons/Feelix-removebg-preview.png';

import {
  auth,
  loginToggle,
  loginModal,
  loginModalClose,
  googleLogin,
  usernameElement,
  navUsernameElement,
  navProfileImg,
  chatHeaderImg,
  menuToggle,
  dropdownMenu,
  navOptions,
  flyersContainer,
  stickyHeading,
  dealModal,
  dealModalOverlay,
  dealModalFavoriteBtn,
  dealModalPageNo,
  dealModalClose,
  chatInput,
  sendBtn,
  chatBody,
  apiStatus,
  modalBackBtn,
  thumbnailStrip,
  imageModal,
  modalContent,
  modalClose,
  galleryPrevBtn,
  galleryNextBtn,
  prevBtn,
  nextBtn,
  zoomInBtn,
  zoomOutBtn,
  resetZoomBtn,
  modalImage,
  getCountryNameFromCode,
  AppState
} from './javascripts/globals.js';

import './javascripts/loc.js';
import './javascripts/ui.js';

import {
  initializeSessionId,
  sendUserDataToServer,
  checkUserExists,
  signInWithGoogle,
  signOutUser,
  updateMobileAuthUI,
  openLoginModal,
  closeLoginModal
} from './javascripts/auth.js';

import {
  checkAPIStatus,
  loadConversationHistory,
  displayLoadedConversationHistory,
  clearConversationHistory,
  setSidebarState,
  sendMessage
} from './javascripts/chat.js';

import {
  loadFlyers,
  loadHomepageDealImages,
  loadUserFavourites,
  preloadFlyerImages,
  loadDeals,
  loadWishlist,
  showDealModal,
  closeDealModal,
  toggleFavorite,
  updateDealModalFavoriteButton,
  loadFlyersView,
  updateStickyHeadingForFlyers
} from './javascripts/data.js';

import {
  setupAccountDropdown,
  setupCountryDropdown,
  setupNavigationOptions,
  setupZoomPrevention,
  updateCountryButton,
  typeWriter,
  showFlyerGallery,
  closeImageModal,
  navigateToPrevImage,
  navigateToNextImage,
  zoomImage,
  resetZoom,
  setupHeroAnimation
} from './javascripts/ui.js';

// ============================================
// PROFILE AVATAR GENERATOR
// ============================================
function generateAvatar(name) {
  const colors = ['#dc143c', '#4ade80', '#3b82f6', '#8b5cf6', '#f59e0b', '#ec4899', '#14b8a6'];
  const initial = (name && name.trim() !== '' ? name : 'U').charAt(0).toUpperCase();
  let hash = 0;
  for (let i = 0; i < (name || '').length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const color = colors[Math.abs(hash) % colors.length];
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect width="100%" height="100%" fill="${color}" /><text x="50%" y="54%" font-family="Arial, sans-serif" font-size="45" font-weight="600" fill="#ffffff" text-anchor="middle" dominant-baseline="middle">${initial}</text></svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

// ============================================
// EVENT LISTENER SETUP
// ============================================

function setupEventListeners() {
  setupAccountDropdown();
  setupCountryDropdown();
  setupNavigationOptions();
  setupHeroAnimation();

  loginToggle.addEventListener("click", openLoginModal);
  loginModalClose.addEventListener("click", closeLoginModal);
  loginModal.addEventListener("click", (e) => {
    if (
      e.target === loginModal ||
      e.target.classList.contains("login-modal-overlay")
    ) {
      closeLoginModal();
    }
  });

  document
    .getElementById("clearChatBtn")
    .addEventListener("click", clearConversationHistory);
  googleLogin.addEventListener("click", signInWithGoogle);

  galleryPrevBtn.addEventListener("click", () => {
    thumbnailStrip.scrollBy({ left: -300, behavior: "smooth" });
  });

  galleryNextBtn.addEventListener("click", () => {
    thumbnailStrip.scrollBy({ left: 300, behavior: "smooth" });
  });

  document.addEventListener("keydown", (e) => {
    if (imageModal.classList.contains("active")) {
      if (AppState.modalMode === "single") {
        if (e.key === "ArrowLeft") navigateToPrevImage();
        else if (e.key === "ArrowRight") navigateToNextImage();
      } else if (AppState.modalMode === "gallery") {
        if (e.key === "ArrowLeft") {
          thumbnailStrip.scrollBy({ left: -300, behavior: "smooth" });
        } else if (e.key === "ArrowRight") {
          thumbnailStrip.scrollBy({ left: 300, behavior: "smooth" });
        }
      }
    }
  });

  modalBackBtn.addEventListener("click", () => {
    if (AppState.currentMerchant) {
      showFlyerGallery(AppState.currentMerchant);
    } else {
      closeImageModal();
    }
  });

  flyersContainer.addEventListener("click", (e) => {
    const dealCard = e.target.closest(".deal-card");
    if (!dealCard) return;

    if (e.target.closest(".deal-favorite-btn")) return;

    const deal = dealCard.dealData;
    if (deal) {
      showDealModal(deal, dealCard);
    }
  });

  dealModalFavoriteBtn.addEventListener("click", () => {
    if (!AppState.currentDealCard) return;

    const deal = AppState.currentDealCard.dealData;
    const index = Array.from(document.querySelectorAll(".deal-card")).indexOf(
      AppState.currentDealCard,
    );
    toggleFavorite(deal, index, AppState.currentDealCard);
    updateDealModalFavoriteButton(deal);
  });

  dealModalOverlay.addEventListener("click", closeDealModal);
  if (dealModalClose) {
    dealModalClose.addEventListener("click", closeDealModal);
  }

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && dealModal.classList.contains("active")) {
      closeDealModal();
    }
  });

  if (dropdownMenu) {
    const dropdownLinks = dropdownMenu.querySelectorAll("a");
    dropdownLinks.forEach((link) => {
      if (link.querySelector(".fa-sign-out-alt")) {
        link.addEventListener("click", (e) => {
          e.preventDefault();
          signOutUser();
        });
      }
    });
  }

  sendBtn.addEventListener("click", sendMessage);
  chatInput.addEventListener("keypress", function (event) {
    if (event.key === "Enter") sendMessage();
  });

  zoomInBtn.addEventListener("click", () => zoomImage("in"));
  zoomOutBtn.addEventListener("click", () => zoomImage("out"));
  resetZoomBtn.addEventListener("click", resetZoom);
  prevBtn.addEventListener("click", navigateToPrevImage);
  nextBtn.addEventListener("click", navigateToNextImage);

  modalImage.addEventListener("wheel", (e) => {
    e.preventDefault();
    if (e.deltaY < 0) zoomImage("in");
    else zoomImage("out");
  });

  modalContent.addEventListener("click", (e) => e.stopPropagation());
  imageModal.addEventListener("click", (e) => {
    if (
      e.target === imageModal ||
      e.target.classList.contains("modal-overlay")
    ) {
      closeImageModal();
    }
  });

  modalClose.addEventListener("click", closeImageModal);

  const navBrowseFlyer = document.getElementById("navBrowseFlyer");
  const mobileBrowseFlyer = document.getElementById("mobileBrowseFlyer");

  async function scrollToFlyers() {
    if (AppState.currentView !== "flyers") {
      await loadFlyersView(); 
    }
    setTimeout(() => {
      const flyerSection = document.getElementById("mainFlyersSection");
      if (flyerSection) {
        flyerSection.scrollIntoView({ behavior: 'smooth', block: 'start' });

        const mobileMenu = document.getElementById("mobileMenu");
        if (mobileMenu && mobileMenu.classList.contains("active")) {
          mobileMenu.classList.remove("active");
        }
      }
    }, 350);
  }

  if (navBrowseFlyer) navBrowseFlyer.addEventListener("click", scrollToFlyers);
  if (mobileBrowseFlyer) mobileBrowseFlyer.addEventListener("click", scrollToFlyers);


  const heroSearchInput = document.getElementById("heroSearchInput");
  const heroSearchSubmit = document.getElementById("heroSearchSubmit");
  const heroSearchBtnText = document.getElementById("heroSearchBtnText");

  function handleHeroSearch() {
    const val = heroSearchInput.value.trim();
    if (!val) return;
    
    setSidebarState(true);
    const chatInput = document.getElementById("chatInput");
    if (chatInput) {
      chatInput.value = val;
      sendMessage();
    }
    
    heroSearchInput.value = "";
  }

  if (heroSearchSubmit) heroSearchSubmit.addEventListener("click", handleHeroSearch);
  if (heroSearchBtnText) heroSearchBtnText.addEventListener("click", handleHeroSearch);

  if (heroSearchInput) {
    heroSearchInput.addEventListener("keypress", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        handleHeroSearch();
      }
    });
  }
}

// ============================================
// INITIALIZATION
// ============================================

async function initializeApp() {
  if ('serviceWorker' in navigator) {
    try {
      await navigator.serviceWorker.register('/sw.js');
    } catch (error) {
      console.error('Service Worker registration failed:', error);
    }
  }

  AppState.SESSION_ID = initializeSessionId();
  loadConversationHistory();
  displayLoadedConversationHistory();
  setSidebarState(false);

  if (auth) {
    try {
      const result = await auth.getRedirectResult();
      if (result && result.user) {
        closeLoginModal(); 
      }
    } catch (error) {
      console.error("Redirect sign-in error:", error);
      alert(`Sign-in failed: ${error.message}`);
      if (googleLogin) {
        googleLogin.innerHTML = `<i class="fab fa-google"></i> Continue with Google`;
        googleLogin.disabled = false;
      }
    }

    auth.onAuthStateChanged((user) => {
      if (user) {
        AppState.isLoggedIn = true;
        AppState.email = user.email;
        AppState.user_uid = user.uid;
        AppState.DISPLAY_NAME = user.displayName || user.email.split("@")[0];
        const photoURL = user.photoURL || null;
        const createdTime = new Date(user.metadata.creationTime).toISOString();
        updateMobileAuthUI(true, AppState.DISPLAY_NAME);

        localStorage.setItem(
          "user",
          JSON.stringify({
            name: AppState.DISPLAY_NAME,
            user_uid: user.uid,
            sessionId: AppState.SESSION_ID,
            email: user.email,
            created_time: createdTime,
            photo_url: photoURL,
            last_login: new Date().toISOString(),
          }),
        );

        (async () => {
          const exists = await checkUserExists(user.uid);
          if (!exists) {
            await sendUserDataToServer({
              created_time: createdTime,
              email: user.email,
              session_id: AppState.SESSION_ID,
              user_uid: user.uid,
              display_name: AppState.DISPLAY_NAME,
              photo_url: photoURL,
            });
          }
        })();

        const firstName = AppState.DISPLAY_NAME.split(" ")[0];
        usernameElement.textContent = firstName.substring(0, 8);
        navUsernameElement.textContent = firstName.substring(0, 8);
          
        loginToggle.style.display = "none";
        menuToggle.style.display = "flex";

        // Assign the dynamic avatar here instead of hardcoding Feelix
        const fallbackAvatar = generateAvatar(AppState.DISPLAY_NAME);
        if (chatHeaderImg) {
          chatHeaderImg.src = user.photoURL || fallbackAvatar;
          chatHeaderImg.alt = user.displayName || "User";
        }
        if (navProfileImg) {
          navProfileImg.src = user.photoURL || fallbackAvatar;
          navProfileImg.alt = user.displayName || "User";
        }

        setTimeout(() => {
          const searchWrapper = document.querySelector('.hero-search-wrapper');
          if (searchWrapper) {
            searchWrapper.classList.add('animate-entrance');
          }
          setTimeout(typeWriter, 300);
        }, 200);

        loadUserFavourites();

      } else {
        AppState.isLoggedIn = false;
        AppState.user_uid = "guest";
        AppState.DISPLAY_NAME = "Guest";
        updateMobileAuthUI(false);
        localStorage.removeItem("user");
        usernameElement.textContent = AppState.DISPLAY_NAME;
        navUsernameElement.textContent = AppState.DISPLAY_NAME;
        loginToggle.style.display = "flex";
        menuToggle.style.display = "none";

        // Generate an avatar for Guest Shopper
        const guestAvatar = generateAvatar("Guest");
        if (chatHeaderImg) {
          chatHeaderImg.src = guestAvatar;
          chatHeaderImg.alt = "Guest";
        }
        if (navProfileImg) {
          navProfileImg.src = guestAvatar;
          navProfileImg.alt = "Guest";
        }

        if (!AppState.hasShownLoginModal) {
          openLoginModal();
          AppState.hasShownLoginModal = true;
        }
        
        loadUserFavourites(); 
      }
    });
  }

  const savedUser = JSON.parse(localStorage.getItem("user"));
  if (savedUser) {
    AppState.user_uid = savedUser.user_uid;
    AppState.DISPLAY_NAME = savedUser.name;
    
    const firstName = AppState.DISPLAY_NAME.split(" ")[0];
    usernameElement.textContent = firstName.substring(0, 8);
    navUsernameElement.textContent = firstName.substring(0, 8);
      
    updateMobileAuthUI(true, AppState.DISPLAY_NAME);

    if (savedUser.email && savedUser.created_time) {
      const exists = await checkUserExists(savedUser.user_uid);
      if (!exists) {
        await sendUserDataToServer({
          created_time: savedUser.created_time,
          email: savedUser.email,
          session_id: AppState.SESSION_ID,
          user_uid: savedUser.user_uid,
          display_name: savedUser.name,
          photo_url: savedUser.photo_url || null,
        });
      }
    }
    if (savedUser.sessionId) {
      AppState.SESSION_ID = savedUser.sessionId;
      localStorage.setItem("walleto_session_id", AppState.SESSION_ID);
    } else {
      savedUser.sessionId = AppState.SESSION_ID;
      localStorage.setItem("user", JSON.stringify(savedUser));
    }

    // Assign dynamic avatar from local storage
    const fallbackAvatar = generateAvatar(savedUser.name || "User");
    if (chatHeaderImg) {
      chatHeaderImg.src = savedUser.photo_url || fallbackAvatar;
      chatHeaderImg.alt = savedUser.name || "User";
    }
    if (navProfileImg) {
      navProfileImg.src = savedUser.photo_url || fallbackAvatar;
      navProfileImg.alt = savedUser.name || "User";
    }
  }

  loadFlyers();
  checkAPIStatus();
  setupZoomPrevention();
  setupEventListeners();
  loadHomepageDealImages();
  loadUserFavourites();
  
  updateCountryButton(AppState.selectedCountryCode);

  setTimeout(() => {
    navOptions.forEach((opt) => {
      opt.style.background = "rgba(255, 255, 255, 0.7)";
      opt.style.color = "#444";
      opt.style.boxShadow = "none";
    });
    
    AppState.currentView = "flyers";
    updateStickyHeadingForFlyers();
    
  }, 10);
  window.addEventListener("beforeunload", clearConversationHistory);
}

// ============================================
// START APPLICATION
// ============================================

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeApp);
} else {
  initializeApp();
}